module.exports = __webpack_public_path__ + "static/img/PG.5aa07f14.svg";